const initialQuotation = {
    quotations: [],
    singlequotations: [],
    quotationmessages : {}
};

const quotationReducer = (quotation = initialQuotation, action) => {
    switch (action.type) {
        case 'GET_QUOTATION':
            return {
                ...quotation, quotations: action.payload.data
            };
        case "ADD_QUOTATIION":
            return {
                ...quotation, quotationmessages: action.payload.data
            };
        case "UPDATE_QUOTATION":
            return {
                ...quotation, quotationmessages: action.payload.data
            };
        case "DELETE_QUOTATION":
            return {
                ...quotation, quotationmessages: action.payload.data
            };   
        case "GET_SINGLE_QUOTATION":
            return {
                ...quotation, singlequotations: action.payload.data
            };
        case "UPDATE_QUOTATION_STATUS":
            return {
                ...quotation, quotationmessages: action.payload.data
            };  
        default:return quotation;

    }
}
export default quotationReducer;